(function() {
  'use strict';

  const CONFIG = {
    maxCheckAttempts: 50, 
    checkInterval: 200,
    processDelay: 500,
    tradeOnlyTags: ['trade-product', 'trade product'],
    selectors: {
      container: '#swym-storefront-layout-items-container',
      items: 'swym-storefront-layout-item',
      priceContainer: '.swym-storefront-layout-grid-item-price-variant',
      addToCartButton: '.swym-storefront-layout-grid-item-add-to-cart-button',
      gridItem: '.swym-storefront-layout-grid-item'
    }
  };

  const productTagsCache = new Map();
  let swymCheckAttempts = 0;
  let mutationObserver = null;

  function initSwymTradeOnlyHandler() {
    console.log('Initializing Swym trade-only handler...');
    swymCheckAttempts = 0;
    
    checkSwymInitialization();
    createSwymObserver();
  }

  function checkSwymInitialization() {
    swymCheckAttempts++;
    
    const swymContainer = document.querySelector(CONFIG.selectors.container);
    const swymItems = document.querySelectorAll(CONFIG.selectors.items);
    
    if (swymContainer && swymItems.length > 0) {
      console.log('Swym wishlist initialized, processing trade-only products...');
      processTradeOnlyProducts();
      return;
    }
    
    if (swymCheckAttempts < CONFIG.maxCheckAttempts) {
      setTimeout(checkSwymInitialization, CONFIG.checkInterval);
    } else {
      console.log('Swym wishlist not found after maximum attempts');
    }
  }

  async function getProductTags(productHandle) {
    // Check cache first
    if (productTagsCache.has(productHandle)) {
      return productTagsCache.get(productHandle);
    }
    
    try {
      const response = await fetch(`/products/${productHandle}.js`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const productData = await response.json();
      const tags = productData.tags || [];
      
      // Cache the result
      productTagsCache.set(productHandle, tags);
      
      return tags;
    } catch (error) {
      console.error(`Error fetching product tags for ${productHandle}:`, error);
      return [];
    }
  }


  function extractProductHandle(productUrl) {
    const match = productUrl.match(/\/products\/([^/?]+)/);
    return match ? match[1] : null;
  }

  function isTradeOnlyProduct(tags) {
    return tags.some(tag => 
      CONFIG.tradeOnlyTags.some(tradeTag => 
        tag.toLowerCase().includes(tradeTag.toLowerCase())
      )
    );
  }

  async function processTradeOnlyProducts() {
    const swymItems = document.querySelectorAll(CONFIG.selectors.items);
    
    for (const item of swymItems) {
      try {
        // Skip if already processed
        if (item.hasAttribute('data-trade-processed')) {
          continue;
        }
        
        // Extract product URL from data attribute
        const productUrl = item.getAttribute('data-du');
        if (!productUrl) continue;
        
        const productHandle = extractProductHandle(productUrl);
        if (!productHandle) continue;
        
        // Get product tags
        const tags = await getProductTags(productHandle);
        
        // Check if product has trade-only tags
        if (isTradeOnlyProduct(tags)) {
            if(!window.customer || !window.customer.includes('b2b'))
                updateTradeOnlyProduct(item);
        }
        
        // Mark as processed
        item.setAttribute('data-trade-processed', 'true');
        
      } catch (error) {
        console.error('Error processing Swym item:', error);
      }
    }
  }

  function updateTradeOnlyProduct(swymItem) {
    // Find and update price container
    const priceContainer = swymItem.querySelector(CONFIG.selectors.priceContainer);
    if (priceContainer) {
      priceContainer.innerHTML = '<span>Trade only product</span>';
    }
    
    // Find and disable add to cart button
    const addToCartButton = swymItem.querySelector(CONFIG.selectors.addToCartButton);
    if (addToCartButton) {
      addToCartButton.disabled = true;
      addToCartButton.style.display = 'none';
    }
    
    // Add visual indicator to the entire item
    const gridItem = swymItem.querySelector(CONFIG.selectors.gridItem);
    if (gridItem) {
      gridItem.classList.add('trade-only-product');
    }
    
    // Add data attribute for styling hooks
    swymItem.setAttribute('data-trade-only', 'true');
  }

  function createSwymObserver() {
    // Cleanup existing observer
    if (mutationObserver) {
      mutationObserver.disconnect();
    }
    
    mutationObserver = new MutationObserver((mutations) => {
      let shouldCheck = false;
      
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          // Check if Swym elements were added
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) { // Element node
              if (node.tagName === 'SWYM-STOREFRONT-LAYOUT-ITEM' || 
                  (node.querySelector && node.querySelector(CONFIG.selectors.items))) {
                shouldCheck = true;
              }
            }
          });
        }
      });
      
      if (shouldCheck) {
        setTimeout(processTradeOnlyProducts, CONFIG.processDelay);
      }
    });
    
    // Start observing
    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    return mutationObserver;
  }

  function cleanup() {
    if (mutationObserver) {
      mutationObserver.disconnect();
      mutationObserver = null;
    }
  }

  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSwymTradeOnlyHandler);
    } else {
      // DOM already loaded, initialize immediately
      setTimeout(initSwymTradeOnlyHandler, 100);
    }
    
    // Cleanup on page unload
    window.addEventListener('beforeunload', cleanup);
  }

  // Auto-initialize
  init();

  // Expose API for manual control if needed
  window.SwymTradeOnlyHandler = {
    init: initSwymTradeOnlyHandler,
    process: processTradeOnlyProducts,
    cleanup: cleanup,
    cache: productTagsCache
  };

})();